<div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
  <div class="flex flex-col gap-3">
    @if (backLabel() && backLink()) {
      <a
        [routerLink]="backLink()"
        class="inline-flex w-fit cursor-pointer items-center gap-1.5 text-sm font-medium text-neutral-500 transition hover:text-neutral-800">
        <app-svg-icon src="assets/icons/arrow-left.svg" [size]="16" />
        {{ backLabel() }}
      </a>
    }

    <div>
      <h1 class="mt-1 text-body1 font-light tracking-tight text-neutral-950 sm:text-3xl">
        {{ title() }}
      </h1>
      @if (description()) {
        <p class="mt-1 max-w-2xl text-sm leading-6 text-neutral-500">
          {{ description() }}
        </p>
      }
    </div>
  </div>

  <ng-content />
</div>
